import { useQuery } from '@apollo/client/react';
import { useMelwaysInfo } from '@seek/melways-react';

import type {
  GetPriorityApplyCreditQuery,
  GetPriorityApplyCreditQueryVariables,
} from 'src/__generated__/graphql';
import { useConfig } from 'src/context/config';
import { GET_PRIORITY_APPLY_CREDIT } from 'src/modules/graphql-client/queries/priorty-apply-credits.graphql';

const usePriorityApplyCredit = () => {
  const timezone =
    // eslint-disable-next-line new-cap
    Intl.DateTimeFormat().resolvedOptions().timeZone || 'Australia/Melbourne';
  const { locale, language } = useMelwaysInfo();
  const { config } = useConfig();

  const { data, loading, error } = useQuery<
    GetPriorityApplyCreditQuery,
    GetPriorityApplyCreditQueryVariables
  >(GET_PRIORITY_APPLY_CREDIT, {
    variables: {
      locale,
      timezone,
      zone: config.ZONE,
      languageCode: language,
      showStrongInterestEndState: true,
    },
    fetchPolicy: 'cache-first',
  });

  const priorityApplyCredit = data?.priorityApplyCredit || null;

  const priorityApplyEnabled = Boolean(
    priorityApplyCredit && priorityApplyCredit.creditConfig,
  );

  const priorityApplyCreditEnabled = Boolean(
    priorityApplyCredit && priorityApplyCredit.credit2,
  );

  return {
    priorityApplyCredit,
    priorityApplyEnabled,
    priorityApplyCreditEnabled,
    data,
    loading,
    error,
  };
};

export { usePriorityApplyCredit };
